export default "__VITE_ASSET__DmDK5Zfe__"